import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, StarIcon } from 'lucide-react';
export function WhatInsideSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const chapters = [{
    number: '01',
    title: 'El Secreto del 1099',
    description: '¿Recibes 1099? Eres dueño de negocio. Empieza a cobrar como uno.'
  }, {
    number: '02',
    title: 'El 15% Oculto',
    description: '¿Trabajas por tu cuenta? Estás pagando un 15% de más si no tienes este conocimiento.'
  }, {
    number: '03',
    title: 'Tu Casa = Tu Oficina',
    description: 'Guía para Uber, DoorDash y Construcción: Tu casa y tu auto son tu oficina.'
  }, {
    number: '04',
    title: 'Deducciones Invisibles',
    description: 'Convierte tus facturas de luz e internet en descuentos de impuestos.'
  }, {
    number: '05',
    title: 'La Lista Maestra',
    description: 'La lista completa de deducciones que el IRS prefiere que no conozcas.'
  }, {
    number: '06',
    title: 'A Prueba de Auditorías',
    description: 'El fin de la ansiedad de abril: Tu declaración 1099 a prueba de auditorías.'
  }];
  return <section ref={ref} className="bg-white py-20 lg:py-28" data-id="element-311">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-313">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#1a2744] text-white rounded-full text-sm font-semibold mb-6" data-id="element-314">
            <BookOpenIcon className="w-4 h-4" data-id="element-315" />
            Contenido del Manual
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2744] leading-tight mb-4" data-id="element-316">
            Lo Que Descubrirás <span className="text-[#c9a227]" data-id="element-317">Adentro</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-318">
            Cada capítulo está diseñado para darte resultados inmediatos y
            accionables.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-319">
          {chapters.map((chapter, index) => <motion.div key={chapter.number} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="group bg-gray-50 hover:bg-[#1a2744] rounded-xl p-6 transition-all duration-300 border border-gray-100 hover:border-[#c9a227]/30" data-id="element-320">
              <div className="flex items-start gap-4" data-id="element-321">
                <div className="w-12 h-12 bg-[#c9a227]/10 group-hover:bg-[#c9a227]/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-322">
                  <span className="text-[#c9a227] font-bold text-lg" data-id="element-323">
                    {chapter.number}
                  </span>
                </div>
                <div data-id="element-324">
                  <h3 className="text-lg font-bold text-[#1a2744] group-hover:text-white mb-2 transition-colors" data-id="element-325">
                    {chapter.title}
                  </h3>
                  <p className="text-gray-600 group-hover:text-gray-300 text-sm transition-colors" data-id="element-326">
                    {chapter.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="bg-gradient-to-r from-[#c9a227]/10 to-[#c9a227]/5 rounded-2xl p-8 border border-[#c9a227]/20" data-id="element-327">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-328">
            <div className="flex-shrink-0" data-id="element-329">
              <div className="w-20 h-20 bg-[#c9a227] rounded-2xl flex items-center justify-center" data-id="element-330">
                <StarIcon className="w-10 h-10 text-[#1a2744]" data-id="element-331" />
              </div>
            </div>
            <div className="text-center md:text-left" data-id="element-332">
              <h3 className="text-xl font-bold text-[#1a2744] mb-2" data-id="element-333">
                🎁 BONUS: Tabla de Rastreo de Millaje 2025
              </h3>
              <p className="text-gray-600" data-id="element-334">
                Obtén tu copia hoy y recibe de regalo mi plantilla profesional
                para rastrear cada milla que manejas.
                <strong className="text-[#1a2744]" data-id="element-335">
                  {' '}
                  Valor: $47 — Tuyo GRATIS.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}